import { Box, Tooltip } from '@mui/material'
import { motion } from 'motion/react'
import { cardHoverAnimation } from '../../../utils/animation'

const CardWithSpace = ({
  tooltipColor, tooltipPlaceHolder, children, flex, customStyles, isClickable, ...props
}) => (
  <Box
    data-testid="card-with-space"
    sx={[styles.root, tooltipColor && styles.containerFix, flex && styles.flex, customStyles]}
    component={motion.div}
    variants={isClickable && cardHoverAnimation}
    whileHover={isClickable && 'hover'}
    {...props}
  >
    {tooltipColor && (
      <Tooltip title={tooltipPlaceHolder} placement="left" arrow>
        <Box sx={styles.sideTooltip} style={{ backgroundColor: `${tooltipColor}` }} />
      </Tooltip>
    )}

    {children}
  </Box>
)

const styles = {
  root: {
    width: '100%',
    backgroundColor: 'white',
    borderRadius: '10px',
    marginBottom: '15px',
    position: 'relative',
  },

  flex: {
    display: 'flex',
    alignItems: 'center',
  },

  containerFix: {
    paddingLeft: '30px',
  },

  sideTooltip: {
    position: 'absolute',
    top: '0',
    bottom: '0',
    left: '0',
    width: '10px',
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
  },
}

export default CardWithSpace
